import React, { useState, useEffect } from "react";
import { Container, Card, Button } from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import DashboardCardHeader from "../../Components/Dashboard/dashboardCardHeader";
import DashProgressBar from "../../Components/Dashboard/progressBar";
import MemberList from "../../Components/Dashboard/memberList";
import { useParams } from "react-router-dom";
import TaskList from "../../Components/Dashboard/taskList";
import { useNavigate } from "react-router-dom";
import { getProjectDetails, updateProjectStatus } from "../../api/casp/project";
import { ProjectStatuses } from "../../constants/Status";
import { toast } from "react-toastify";
import { hasModulePermission } from "../../helpers/permission";
import { Modules } from "../../constants/Module";
import { Action } from "../../constants/Common";
import { Spinner } from "reactstrap";
import Loader from "../../Components/Common/Loader";
import { ProjectStatusColor } from "../../constants/StatusColor";
import DescriptionIcon from "@mui/icons-material/Description";
import ShowCommentModal from "../../Components/casp/common/ShowCommentModal";
import { Helmet } from 'react-helmet';
import { getIconPath } from "../../helpers/file_helper";
import { filter } from 'lodash/collection'
import { get } from 'lodash/object'
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import ApexColumnBarChart from "../../Components/Common/ApexColumnBarChart";
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import DashboardStatics from "../../Components/Dashboard/dashboardStatics";
import { getDashboardCardCount } from "../../api/casp/dashboard";
import ApexColumnBarChart1 from "../../Components/Common/ApexColumnBarChartProjectStatus";
import ApexColumnBarChartProjectSatus from "../../Components/Common/ApexColumnBarChartProjectStatus";
import { withTranslation } from "react-i18next";
import { Role } from "../../constants/Role";
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import { useSelector } from "react-redux";
import { t } from "i18next";
import { Tooltip } from "@mui/material";
import ContentInfo from "../../common/contentInfo";
import NotFound from "../../Components/Common/PageNotFound";

function Dashboard(props) {
  const { projectId } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingForSubmit, setIsLoadingForSubmit] = useState(false);
  const [projectDetails, setProjectDetails] = useState();
  const [openRejectModel, setOpenRejectModel] = useState(false);
  const [rejectReason, setRejectReason] = useState();
  const [projectStatus, setProjectStatus] = useState()
  const [cardcount, setCardCount] = useState();
  const { projectUser } = useSelector((state) => ({
    projectUser: state.projectUser.projectUser,
  }));

  const hasPermission = hasModulePermission(Modules.PROJECT, Action.EDIT)

  useEffect(() => {
    if (projectId) {
      fetchProjectDetails();
    }
  }, []);

  const fetchProjectDetails = async () => {
    try {
      setIsLoading(true);
      const project = await getProjectDetails(projectId);
      setProjectDetails(project.data.data);
      setProjectStatus(project.data.data.status)
    } catch (error) {
      console.log(error);
      toast.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const projectSubmit = async () => {
    try {
      if (!projectDetails?.description || !projectDetails?.scope) {
        return toast.error('Please add description and scope before submit project')
      }

      setIsLoadingForSubmit(true);
      const res = await updateProjectStatus(parseInt(projectId), {
        status: [ProjectStatuses.ONGOING, ProjectStatuses.CONFIRMATION_REJECTED].includes(projectDetails.status) ? ProjectStatuses.COMPLETED : ProjectStatuses.ONGOING,
      });
      if (res.statusCode === 200) {
        toast.success(res.data.message);
        fetchProjectDetails()
      } else {
        toast.error(res.message);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoadingForSubmit(false);
      toast.error(error.message);
    }
  };

  const handleOpen = (comment, data) => {
    setOpenRejectModel(true);
    setRejectReason({
      name: data?.name,
      profilePicture: data?.profilePicture,
      role: data?.projectUsers[0]?.role?.name ?? '',
      comment,
    });
  };

  const handleRejectModal = () => {
    setOpenRejectModel(!openRejectModel);
    setRejectReason()
  };

  return (
    <React.Fragment>
      <div className="page-content position-relative mainDashboardPg">
        <Helmet
          onChangeClientState={(newState, addedTags) => {
            try {
              // Check if we added any new link[rel="icon"] elements.
              const newFaviconElems = filter(get(newState, 'linkTags', []), {
                rel: 'icon',
              })

              if (!newFaviconElems.length) {
                return
              }

              // Get the href of the last link element we just added, which
              // we assume is the most recently-added favicon.
              const newFaviconHref =
                newFaviconElems[newFaviconElems.length - 1].href

              // Remove all react-helmet link elements with rel="icon" that
              // do not have the href of our recently-added favicon.
              // If no other favicon elements exist, we don't have to do
              // anything.
              const existingFavicons = document.querySelectorAll(
                `link[rel="icon"][data-react-helmet]:not([href="${newFaviconHref}"])`
              )

              if (existingFavicons.length) {
                existingFavicons.forEach(e => e.parentNode.removeChild(e))
              }

              // Remove and re-add the latest link element to make sure
              // the browser uses it.
              const newFaviconElem = document.querySelector(
                `link[rel="icon"][data-react-helmet][href="${newFaviconHref}"]`
              )

              if (newFaviconElem) {
                const newFavElement = newFaviconElem.cloneNode(true)
                newFavElement.href = `data:image/svg+xml,${encodeURIComponent(
                  `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>${getIconPath(<DashboardOutlinedIcon />)}</svg>`
                )}`
                const parentElem = newFaviconElem.parentNode
                parentElem.removeChild(newFaviconElem)
                parentElem.appendChild(newFavElement)
              }
            } catch (e) {
              console.error(e)
            }
          }}
        >
          <title>{props.t("Project Dashboard")}</title>
        </Helmet>
        <Container fluid>
          {projectDetails && !isLoading &&
            <>
              {/* BreadCrumb area starts */}
              <div className="mainPageHeader d-flex justify-content-between mb-3">
                <div className="d-flex align-items-center">
                  {projectId && [
                    Role.PORTFOLIO_MANAGER,
                    Role.PROJECT_SPONSOR,
                    Role.PROJECT_OWNER
                  ].includes(projectUser?.role?.name) &&
                    <ArrowBackOutlinedIcon className="me-2 cursor-pointer" onClick={() => navigate(`/project/${projectId}/project-approval`)} />
                  }
                  <BreadCrumb title={`${props.t("Dashboard")}`} />
                </div>
                <div className=" d-flex justify-content-center align-items-center">
                  <h6
                    className={`statusBadge ${ProjectStatusColor(projectDetails.status)} badge-outlined mt-2`}
                  >
                    {projectDetails.status}
                    {projectDetails.status === ProjectStatuses.IN_APPROVAL &&
                      <ContentInfo content={projectDetails?.latestApproval?.currentApprovalUser} />
                    }
                  {[ProjectStatuses.REJECTED, ProjectStatuses.CONFIRMATION_REJECTED].includes(projectDetails.status) && (
                      <DescriptionIcon
                        style={{ cursor: "pointer", height: '18px' }}
                        onClick={() =>
                          handleOpen(
                            projectDetails.previousApproval?.comments,
                            projectDetails.previousApproval?.currentApprovalUser?.user
                          )
                        }
                      />
                    )}
                  </h6>
                  <div className="ms-2">
                    <Button
                      onClick={() =>
                        navigate(`/project/${projectId}/details`)
                      }
                      className="w-100 main-login-btn btn btn-secondary d-flex align-items-center"
                    >
                      <RemoveRedEyeIcon className="d-inline-block me-2" style={{ fontSize: '17px' }} /> {props.t("View Details")}
                    </Button>
                  </div>
                {hasPermission && projectUser?.role?.name === Role.PROJECT_MANAGER && [ProjectStatuses.DRAFT, ProjectStatuses.REJECTED, ProjectStatuses.CONFIRMATION_REJECTED, ProjectStatuses.ONGOING].includes(projectDetails?.status) &&
                    <button
                      onClick={projectSubmit}
                      className="edit_button deliverables_submit ms-3"
                      disabled={isLoadingForSubmit}
                    >
                      {isLoadingForSubmit && (
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                          className="me-1"
                        />
                      )}
                    {[ProjectStatuses.DRAFT, ProjectStatuses.REJECTED].includes(projectDetails?.status) ? props.t("Submit") : props.t("Complete")}
                    </button>
                  }
                </div>
              </div>
              <h5 className="mb-3">
                {`${projectDetails.name} (${projectDetails.uniqueProjectId})`}
              </h5>

              <DashboardStatics projectId={projectId} />

              <div className="viewProjApprovalContent accordionTable">
                <div className="row">
                  <div className="col-sm-8">
                    <TaskList projectId={projectId} />
                    <div className="row">
                      <div className="col-sm-6">
                        <Card className="customCard p-3">
                          <DashboardCardHeader
                            title={props.t("Project’s Status")}
                            borderBottom="false"
                            fontSize="18px"
                          />
                          <ApexColumnBarChartProjectSatus projectId={projectId} />
                        </Card>
                      </div>
                      <div className="col-sm-6 ps-0">
                        <Card className="customCard p-3">
                          <DashboardCardHeader
                            title={props.t("Budget")}
                            borderBottom="false"
                            fontSize="18px"
                          />
                          <ApexColumnBarChart projectId={projectId} />
                        </Card>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-4 ps-0">
                    {/* <Card className="customCard p-3">
                    <DashboardCardHeader
                      title={props.t("Status")}
                      borderBottom="false"
                      fontSize="18px"
                      paddingLeft="0px"
                    />
                  {projectDetails.status === ProjectStatuses.REJECTED && (
                    <DescriptionIcon
                      className="redTxt cursor-pointer mt-1"
                      onClick={() =>
                        handleOpen(
                          projectDetails.previousApproval?.comments,
                          projectDetails.previousApproval?.currentApprovalUser?.user
                        )
                      }
                    />
                  )}
                    {projectDetails.status === ProjectStatuses.IN_APPROVAL && (
                    <h6><strong>Waiting for approval </strong>from {projectDetails?.latestApproval?.currentApprovalUser?.user?.name} ({projectDetails?.latestApproval?.currentApprovalUser?.user?.projectUsers[0]?.role?.name})</h6>
                  )}
                  </Card> */}
                    <Card className="customCard p-3">
                      <DashboardCardHeader
                        title={props.t("Project Progress")}
                        borderBottom="false"
                        fontSize="18px"
                        paddingLeft="0px"
                      />
                      <DashProgressBar projectId={projectId} source={t('Milestones')} />
                    </Card>
                    {/* <Card className="customCard p-3">
                        <div className="dashDesignationHeader d-flex justify-content-between align-items-center px-3 mb-2">
                            <div className="designation d-flex align-items-center">
                                <img src={Designation} alt={Designation} />
                                <div className="designationHead mx-2">Designation</div>
                            </div>
                            <div className="designationRate d-flex align-items-center">
                                <img src={Designation} alt={Designation} />
                                <div className="designationHead mx-2">Rate</div>
                            </div>
                        </div>
                        <ul className="dashDesignationContent list-inline mb-0">
                            {designationList.map((item, index) => (
                                <li key={index} className="d-flex justify-content-between">
                                    <div className="dashDesignationImage d-flex align-items-center">
                                        <div className="designationIcon">
                                            <img src={item.designationIcon} alt={item.designationIcon} />
                                        </div>
                                        <div className="mb-0">{item.designation}</div>
                                    </div>
                                    <div className="designationRate d-flex align-items-center">

                                        <span>{item.rate}</span>
                                        <div className="designationEditIcon"><ModeEditOutlineOutlinedIcon /></div>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </Card> */}
                    <MemberList projectId={projectId} />
                  </div>
                </div>
                {/* <div className="row mt-2"> */}
                {/* <div className="col-sm-8">
                  <Card className="customCard p-3">
                    <DashboardCardHeader
                      title="Budget"
                      borderBottom="false"
                      fontSize="18px"
                    />
                    <DashboardBarChart />
                  </Card>
                </div> */}
                {/* <div className="col-sm-4">
                    <MemberList projectId={projectId} />
                </div> */}
                {/* </div> */}
              </div>
            </>
          }

          {!projectStatus && isLoading && <Loader />}
          {/* {!projectStatus && !isLoading && <NotFound />} */}
        </Container>
      </div>

      <div className="rejectModal">
        <ShowCommentModal
          handleRejectModal={handleRejectModal}
          open={openRejectModel}
          module={Modules.CHANGE_REQUEST}
          data={rejectReason}
        />
      </div>
    </React.Fragment>
  );
}

export default withTranslation()(Dashboard);
